import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { VitalSign } from '../model/vital-sign';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class VitalSignService {
  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : VitalSign[];
  vitalData : VitalSign;
  constructor(http: HttpClientService, cook: CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  saveVitalSign(): Observable<VitalSign> {
    this.objAction.header = null;
    this.objAction.data = this.vitalData;
    this.objAction.path = 'api/VitalSign/CreateVitalSign';
    return this.objAction.save();
  }
 getVitalSign(PatientId : number):   Observable<VitalSign[]> {
    this.objAction.path = 'api/VitalSign/GetVitalSign?PatientId='+ PatientId;
    return this.objAction.get();
 }
 updateVitalSign(): Observable<VitalSign> {
    this.objAction.header = null;
    this.objAction.data = this.vitalData;
    this.objAction.path = 'api/VitalSign/UpdateVitalSign';
    return this.objAction.update();
 }
 deleteVitalSign(usr: VitalSign): Observable<VitalSign> {
  this.objAction.header = null;
  this.objAction.path = 'api/VitalSign/DeleteVitalSign?strVitalSignId=' + usr.VitalSignId;
  return this.objAction.delete();
}

}



// WEBPACK FOOTER //
// ./src/app/section/patient/service/vital-sign.service.ts